<script>
import Layout from "../../../../layouts/main";

import appConfig from "@/app.config";
// import PageHeader from "@/components/page-header";
import EmployeeFiles from "../EmployeeFiles/index.vue";
// import EmpWorkdays from "../EmpWorkdays/index.vue";
import EmpsSalaryItems from "../EmpSalaryItems/index.vue";
import EmployeeLoans from "../EmployeeLoans/index.vue";
import HrCustody from '../HrCustody/index.vue'
import shiftSetup from "../EmployeeShift/shiftSetup.vue";
import CalnderPage from "../EmployeeCalendar/CalnderPage.vue";
import EmployeePenalty from "../EmployeePenalty/EmployeePenalty.vue";
import Employeeleave from "../EmployeeLeave/Employeeleave.vue";
import EmployeeAward from "../EmployeeAward/EmployeeAward.vue";

// import EmployeeFiles from "./EmployeeFiles/index.vue";
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    // PageHeader,
    EmployeeFiles,
    // EmpWorkdays,
    EmpsSalaryItems,
    EmployeeLoans,
    HrCustody,
    shiftSetup,
    CalnderPage,
    EmployeePenalty,
    EmployeeAward,
    Employeeleave
  },
  data() {
    return {
      employee: {},
      informations: [],
      activate_calendar: {},
    };
  },
  methods: {
    getEmployee() {
      this.http.get("emps/" + this.$route.params.id).then((res) => {
        this.employee = res.data;
      });
    },
    getEmployeeData() {
      this.http
        .post("emps/select-employee-data", {
          id: parseInt(this.$route.params.id),
        })
        .then((resp) => {
          this.employee = resp.data;
          // this.hr_job_title = resp.data?.hr_job_title;
          // resp.data?.employeeDepartments.forEach((department) => {
          //   this.hr_department.push(department?.hr_department);
          // });
          this.profileTitle = this.employee?.name;
          this.informations = resp.data;

          console.log('infoaa', this.informations)
          this.code = this.informations?.hr_working_schedule_type?.code
          // this.informations[0] = {
          //   employee: resp.data?.hr_employee,
          // };
        });
    },
  },
  created() {
    this.getEmployee();
    this.getEmployeeData()
  },
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" :title="$t('popups.profile')" /> -->
    <div class="row">
      <div class="row align-items-center">
        <div class="d-flex align-items-center mb-4">
          <router-link :to="`/emps`">
            <h4 class="m-0">{{ $t("menu.menuitems.hr.subItems.emps") }}</h4>
          </router-link>
          <div class="mx-2">\</div>
          <div>
            {{
              $i18n.locale == "ar"
                ? "بروفايل " + employee?.name
                : employee?.name + " profile"
            }}
          </div>
        </div>
      </div>
    </div>
    <!-- start personal informations -->
    <b-tabs
      justified
      nav-class="nav-tabs-custom"
      content-class="p-3 text-muted"
    >
      <b-tab active>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-home"></i>
          </span>
          <span class="d-none d-sm-inline-block"
            >{{ $t("emps.tabs.files") }}
          </span>
        </template>
        <EmployeeFiles />
      </b-tab>
      <!-- <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-home"></i>
          </span>
          <span class="d-none d-sm-inline-block"
            >{{ $t("emps.tabs.working_days") }}
          </span>
        </template>
        <EmpWorkdays />
      </b-tab> -->
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-home"></i>
          </span>
          <span class="d-none d-sm-inline-block"
            >{{ $t("hr_employees.shiftsetup") }}
          </span>
        </template>
        <shiftSetup :employee_data="informations"/>
      </b-tab>
      <b-tab>
        <template v-slot:title>
          <div @click="activate_calendar.loadCalendar();">
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block"
              >{{ $t("hr_employees.employee_profile.calendar") }}
            </span>
          </div>
        </template>
        <CalnderPage :employee_data="informations" :activate_calendar="activate_calendar" />
      </b-tab>
      <b-tab>
        <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block"
              >{{ $t("hr_employees.employee_profile.leave") }}
            </span>
        </template>
        <Employeeleave />
      </b-tab>
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-home"></i>
          </span>
          <span class="d-none d-sm-inline-block"
            >{{ $t("hr_employees.tabs.penalty") }}
          </span>
        </template>
        <EmployeePenalty />
      </b-tab>
            <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-home"></i>
          </span>
          <span class="d-none d-sm-inline-block"
            >{{ $t("hr_employees.tabs.award") }}
          </span>
        </template>
        <EmployeeAward />
      </b-tab>
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-home"></i>
          </span>
          <span class="d-none d-sm-inline-block"
            >{{ $t("emps.tabs.emp_salary_items") }}
          </span>
        </template>
        <EmpsSalaryItems />
      </b-tab>
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-home"></i>
          </span>
          <span class="d-none d-sm-inline-block"
            >{{ $t("emps.tabs.emp_loans") }}
          </span>
        </template>
        <EmployeeLoans />
      </b-tab>
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-home"></i>
          </span>
          <span class="d-none d-sm-inline-block"
            >{{ $t("hr_employees.custody") }}
          </span>
        </template>
        <hr-custody />
        <!--end-->
      </b-tab>
      <!-- <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-home"></i>
          </span>
          <span class="d-none d-sm-inline-block"
            >{{ $t("emps.tabs.attendance") }}
          </span>
        </template>
        <h2>hello</h2>
      </b-tab> -->
    </b-tabs>

    <!-- end personal informations -->
  </Layout>
</template>
<style scoped></style>
